import './style.scss'

export default function Footer(){
    return <div className="footer">
      Copyright mars 2023  / Mélanie Mariani & Louise Sola / 06 73 55 77 01 /<a href="mailto:le.moulin.a.web@gmail.com" className='email'>&nbsp;Contactez-nous !</a>
  
    </div>
}